/** Returns true for the team-level Projects list route (`…/files`, exact).
 *
 *  Scope injection is skipped on this route so that clicking the "Projects" tab
 *  lands on `/files` WITHOUT `scopeId`/`scopeType` params. Otherwise, arriving
 *  from a project would flash a stale project scope into the URL and leave the
 *  team-level breadcrumb and settings gear pointing at the wrong scope. Nested
 *  routes (`/files/projects/…`, `/files/create-project`, etc.) still inject. */
export function isProjectsListPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return /\/files\/?$/.test(pathname);
}
